import styled from "styled-components";
import { Link } from "react-router-dom";
import { media } from "../../styles/media";

export const FooterRoot = styled.footer`
  margin-top: 3rem;
  padding: 2.5rem 0;
  background: hsl(${({ theme }) => theme.colors.navDark});
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: ${({ theme }) => theme.layout.shellMax};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.layout.shellPadX};
  ${media.md} {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const ColSpan2 = styled.div`
  grid-column: span 2;
  ${media.md} {
    grid-column: span 1;
  }
`;

export const BrandRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 800;
  font-size: clamp(1.0625rem, 0.95rem + 0.4vw, 1.25rem);
  margin-bottom: 0.75rem;
`;

export const BrandBadge = styled.span`
  background: hsl(${({ theme }) => theme.colors.accent});
  color: hsl(${({ theme }) => theme.colors.accentForeground});
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  font-size: clamp(0.8125rem, 0.78rem + 0.15vw, 0.9375rem);
`;

export const BrandText = styled.span`
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

export const MutedP = styled.p`
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
  margin: 0 0 1rem;
`;

export const SocialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const SocialA = styled.a`
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  background: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
  transition: background 0.15s;
  &:hover {
    background: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.2);
  }
`;

export const ColTitle = styled.h4`
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
  margin: 0 0 0.75rem;
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
`;

export const LinkStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FooterLink = styled(Link)`
  font-size: clamp(0.875rem, 0.82rem + 0.2vw, 1rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
  &:hover {
    color: hsl(${({ theme }) => theme.colors.accent});
  }
`;

export const BottomBar = styled.div`
  border-top: 1px solid hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.1);
  margin-top: 2rem;
  padding-top: 1.5rem;
  max-width: ${({ theme }) => theme.layout.shellMax};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.layout.shellPadX};
  padding-right: ${({ theme }) => theme.layout.shellPadX};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: clamp(0.8125rem, 0.78rem + 0.15vw, 0.9375rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.4);
  ${media.sm} {
    flex-direction: row;
  }
`;
